import type { CertificationPreview } from "@brookbush/types";

import useSWR, { type SWRResponse } from "swr";

const useCertifications = () => {
	const {
		data: certifications,
		isLoading,
		...rest
	} = useSWR("/certifications") as SWRResponse<CertificationPreview[]> & {
		data: CertificationPreview[];
	};

	return {
		certifications,
		isLoading,
		isLoadingCertifications: isLoading,
		...rest,
	};
};

export default useCertifications;
